import type { WithAsChild } from "@packages/ui";
import type { ComponentPropsWithoutRef } from "react";
import { Fragment } from "react";

export const FragmentAsChild = (
  props: WithAsChild<ComponentPropsWithoutRef<typeof Fragment>>,
) => <Fragment>{props.children}</Fragment>;
